import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { constant, debounce } from 'lodash';
import { EmployeeService } from 'src/app/api/admin/company/employee.service';
import { ClientService } from 'src/app/api/sale/client.service';
import { TourService } from 'src/app/api/tourism/tour.service';
import { constants } from 'src/app/constants';
import * as _ from 'underscore';
declare var $: any;


@Component({
  selector: 'component-search-employee',
  templateUrl: './search-employee.component.html',
  styleUrls: ['./search-employee.component.css']
})
export class SearchEmployeeComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @Output() selectedEmployeeEvent = new EventEmitter<string>();
  @Input() classSize: string | null = null;

  data = [];
  keyword = 'fullname_str';
  isTypedSearch = false;
  classSearch:any;

  constructor(private employeeService: EmployeeService) {
  }

  ngOnInit() {
    this.classSearch = this.classSize; 
  }

  debouncedSearchInput = debounce(event => this.getSearchTours(event), 250);

  getSearchTours(search_: any) {
    this.isTypedSearch = true;
    if (search_.length > 1) {
      let val_params = 'search=' + search_;
      this.employeeService.search(val_params).subscribe({
        next: (data: any) => {
          this.data = data.results;
          this.data.map((item:any) => item.fullname_str = `${item.fullname} ${item.document}`);
        }
      });
    } else {
      this.data = [];
    }
  }

  selectSearch(item: any) {
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
      (<any>$('.autocomplete-container .not-found')).hide();
    }, 10);
    
    this.selectedEmployeeEvent.emit(item);
    this.data = [];
  }

  closedSearchPanel(): void {
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  clearedInputSearch(): void {
    this.searchInput.focus();    
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  focused() {
    this.searchInput.focus(); 
  }
}
